// extracted by mini-css-extract-plugin
export default {"customFormStyle":"form_customFormStyle__jJmnY","invertedBgTheme":"form_invertedBgTheme__L0zry"};